import { ApiProvider } from '@leverege/api-redux';
import { Button } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { useContext, useState, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  id: 'ui-video.actions.Link',
  appearance: ({
    context
  }) => {
    const {
      isLoading
    } = context;
    return {
      icon: 'fa fa-fw fa-link',
      variant: 'link',
      disabled: isLoading
    };
  },
  matches: {
    use: 'videoOptionsBar'
  },
  handles: () => {
    const roles = GlobalState.get()?.ui?.personas || [];

    // for admin eyes only
    return roles.some(role => role.name === 'default');
  },
  layout: {
    sort: 'zz'
  },
  customComponent: VideoLink
};
function VideoLink({
  context,
  factory
}) {
  const [loading, setLoading] = useState(false);
  const api = useContext(ApiProvider.Context);
  const onClick = useCallback(async () => {
    const {
      clientProps: {
        delegate
      }
    } = context;
    const interfaceUrl = delegate.getInterfaceUrl();
    try {
      setLoading(true);
      const {
        url
      } = await api.child(`v1/interface/${interfaceUrl}.srv/streamProxy/stream/url`).get();
      setLoading(false);
      window.open(url, '_blank');
    } catch (err) {
      console.error(err);
    }
  }, []);
  return /*#__PURE__*/_jsx(Button, {
    variant: factory.variant,
    icon: loading ? 'fa fa-fw fa-loader fa-spin' : 'fa fa-fw fa-link',
    onClick: onClick
  });
}